import React, { useCallback, useRef, useState } from 'react';
import {
  Row, Col, Container, Button,
} from 'reactstrap';
import _ from 'lodash';

import {
  Intl, RatesModal, PaymentMethodModal, ConfirmationModal,
} from 'components';
import classnames from 'classnames';
import { formatNumeral } from 'utils';

const ItemCol = ({ title, className, children }) => (
  <Col md={6} className={className}>
    <Row>
      <Col>
        <div className="text-center bg-gray-3 text-sm font-weight-bold py-1">
          {title}
        </div>
      </Col>
    </Row>
    <Row>
      <Col style={{ minHeight: '160px' }}>
        <div
          className="bg-mp-gray-3 text-center pt-2 pb-3 px-2 h-100 d-flex flex-column justify-content-center align-items-center"
          style={{ borderTop: '2px solid white' }}
        >
          {children}
        </div>
      </Col>
    </Row>
  </Col>
);

export default ({
  data, rates, accountPlanId, accountPlanType, isLoading,
  onSubmit, onSubmitFormNoFee, onReload, onReloadAccount, userData, accountData,
}) => {
  const [ratesModal, setRatesModal] = useState(false);
  const [noFeeConfirmationModal, setNoFeeConfirmationModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const paymentRef = useRef(null);
  const noFeePlanRef = useRef(null);

  const toggleRatesModal = useCallback(() => {
    setRatesModal((state) => !state);
  }, []);

  const toggleNoFeeConfirmationModal = useCallback((id) => {
    if (id) noFeePlanRef.current = id;
    setNoFeeConfirmationModal((state) => !state);
  }, []);

  const togglePaymentModal = useCallback((planPrice, id, type) => {
    if (planPrice) {
      const iva = ((accountData && accountData.taxes) || (accountData && accountData.vat == "")) ? Number(planPrice) * 0.21 : 0;
      paymentRef.current = {
        amount: formatNumeral(planPrice),
        iva: iva > 0 ? formatNumeral(iva) : iva,
        total: formatNumeral(iva + Number(planPrice)),
        type,
        id,
      };
    } else paymentRef.current = null;

    setPaymentModal((state) => !state);
  }, [accountData]);

  const title = useCallback(plan => {
    const name = plan.name;
    const symbol = plan.label === 'FEE' ? `(${userData.currency_symbol})` : '';
    return `${name} ${symbol}`;
  }, [])

  return (
    <Container
      fluid
      className={classnames({ 'app-component-loading': isLoading })}
    >
      <Row>
        <Col>
          <p className="mb-1"><Intl id="planSwitcher" /></p>

          <Row>
            {_.map(data, (plan) => (
              // <ItemCol key={plan.id} title={`${plan.name} (${userData.currency_symbol})`} className="mt-4">
              <ItemCol key={plan.id} title={title(plan)} className="mt-4">
                <p className="text-sm m-0 lh-150">
                  <Intl id="planCallPerMinute" />
                </p>
                <p className="text-sm m-0 lh-150">
                  <Intl id="planMultipleUsers" />
                </p>
                <p className="text-sm m-0 lh-150">
                  <Intl id="planPricePerPhone" values={{ value: formatNumeral(plan.minValue), currency: userData.currency_symbol }} />
                  {' - '}
                  <Button color="outline-link" className="p-0" onClick={toggleRatesModal}>
                    <Intl id="seeCountries" />
                  </Button>
                </p>
                {plan.label === 'FEE' ? <p className="text-sm m-0 lh-150">
                  <Intl id="planCashback" />
                </p> : <p className="text-sm m-0">-</p>}

                {
                  plan.label === 'FEE' ?
                    <div className="d-md-flex">
                      <Button
                        color="app-default"
                        size="app-sm"
                        className="mt-3 mr-0"
                        disabled={plan.id === accountPlanId && accountPlanType === 'monthly'}
                        onClick={() => togglePaymentModal(plan.feeMonthly, plan.id, 'month')}
                      >
                        <Intl id="planSwitchMonthly" values={{ value: plan.feeMonthly, currency: userData.currency_symbol }} />
                      </Button>

                      <Button
                        color="app-default"
                        size="app-sm"
                        className="mt-3"
                        disabled={plan.id === accountPlanId && accountPlanType === 'annual'}
                        onClick={() => togglePaymentModal(plan.feeAnnual, plan.id, 'year')}
                      >
                        <Intl id="planSwitchYear" values={{ value: plan.feeAnnual, currency: userData.currency_symbol }} />
                      </Button>
                    </div>
                    :
                    <Button
                      color="app-default"
                      size="app-sm"
                      className="mt-3"
                      onClick={() => toggleNoFeeConfirmationModal(plan.id)}
                      disabled={plan.id === accountPlanId}
                    >
                      <Intl id="switchToNoFee" />
                    </Button>
                }

              </ItemCol>
            ))}

            {/* <ItemCol title={<Intl id="custom" />} className="mt-4">
              <a className="text-mp-blue-1 text-sm" href="mailto:help@massphoning.com">
                <Intl id="planContactUs" />
              </a>
            </ItemCol> */}

            {/* {_.map(data.data, (plan) => (
              <ItemCol key={plan.id} title={`${plan.name} (${userData.currency_symbol})`} className="mt-4">
                <p className="text-sm m-0 lh-150">
                  <Intl id="planCallPerMinute" />
                </p>
                <p className="text-sm m-0 lh-150">
                  <Intl id="planMultipleUsers" />
                </p>
                <p className="text-sm m-0 lh-150">
                  <Intl id="planPricePerPhone" values={{ value: formatNumeral(plan.minValue), currency: userData.currency_symbol }} />
                  {' - '}
                  <Button color="outline-link" className="p-0" onClick={toggleRatesModal}>
                    <Intl id="seeCountries" />
                  </Button>
                </p>
                <p className="text-sm m-0 lh-150">
                  <Intl id="planCashback" />
                </p>

                <div className="d-md-flex">
                  <Button
                    color="app-default"
                    size="app-sm"
                    className="mt-3 mr-0"
                    disabled={plan.id === accountPlanId && accountPlanType === 'monthly'}
                    onClick={() => togglePaymentModal(plan.feeMonthly, plan.id, 'month')}
                  >
                    <Intl id="planSwitchMonthly" values={{ value: plan.feeMonthly, currency: userData.currency_symbol }} />
                  </Button>

                  <Button
                    color="app-default"
                    size="app-sm"
                    className="mt-3"
                    disabled={plan.id === accountPlanId && accountPlanType === 'annual'}
                    onClick={() => togglePaymentModal(plan.feeAnnual, plan.id, 'year')}
                  >
                    <Intl id="planSwitchYear" values={{ value: plan.feeAnnual, currency: userData.currency_symbol }} />
                  </Button>
                </div>
              </ItemCol>
            ))} */}

            <ItemCol title={<Intl id="custom" />} className="mt-4">
              <a className="text-mp-blue-1 text-sm" href="mailto:help@massphoning.com">
                <Intl id="planContactUs" />
              </a>
            </ItemCol>
          </Row>

          <p className="text-sm m-0">
            <Intl id="vatNotIncluded" />
          </p>
        </Col>
      </Row>

      {ratesModal
        && (
          <RatesModal
            data={rates}
            // plans={[...data.fee, ...data.noFee]}
            plans={[...data]}
            open={ratesModal}
            onClose={toggleRatesModal}
            userData={userData}
          />

        )}
      {paymentModal
        && (
          <PaymentMethodModal
            data={paymentRef.current}
            open={paymentModal}
            onClose={togglePaymentModal}
            onSubmit={(paymentData, ...rest) => onSubmit(
              { ...paymentData, planType: paymentRef.current.type, id: paymentRef.current.id }, ...rest,
            )}
            onSuccessPayment={() => {
              onReload();
              onReloadAccount();
              togglePaymentModal();
            }}
          />
        )}

      <ConfirmationModal
        open={noFeeConfirmationModal}
        onClose={toggleNoFeeConfirmationModal}
        title="planChangeConfirmation"
        onConfirm={() => {
          onSubmitFormNoFee(noFeePlanRef.current);
          toggleNoFeeConfirmationModal();
        }}
      />
    </Container>
  );
};
